import { acknowledgementEmailTemplate } from "./EmailTemplates/AcknowledgeEmailTemplate";
import { clientRequestEmailTemplate } from "./EmailTemplates/ClientRequestEmailTemplate";




const clientContactDetailsEmailFormat = (
  name,
  message,
  email,
  phone_number,
  workorder_id
) => {
  return clientRequestEmailTemplate(
    name,
    message,
    email,
    phone_number,
    workorder_id
  );
};

const acknowledgementEmailFormat = (name) => {
  return acknowledgementEmailTemplate(name);
};

const removeHtmlTags = (myStr) => {
  // /(<([^>]+)>)/gi
  if (myStr === null || myStr === "") return "";
  else myStr = myStr.toString();
  console.log(myStr);
  return myStr.replace(/(<([^>]+)>)/gi, "");
};

const filterValue = (data, filterName) => {
  return data?.filter((x) => x.name === filterName)[0]?.label;
};

export {
  clientContactDetailsEmailFormat,
  acknowledgementEmailFormat,
  removeHtmlTags,
  filterValue
};